import { render } from "./UiClose.vue?vue&type=template&id=8a120844&scoped=true&lang=pug"
import script from "./UiClose.vue?vue&type=script&lang=js"
export * from "./UiClose.vue?vue&type=script&lang=js"

import "./UiClose.vue?vue&type=style&index=0&id=8a120844&lang=sass&scoped=true"

import exportComponent from "D:\\Front\\project\\valeriya.artist\\valeriya.artist.admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a120844"]])

export default __exports__